import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useAccessToken } from 'utils/auth';
import { CreateCvRequest } from './api-types';
import { cvApi } from './client';

const TALENT_CV_QUERY_KEY = 'talentCv';

export const useTalentCvQuery = (token: string | undefined) =>
  useQuery([TALENT_CV_QUERY_KEY, token], () => cvApi.fetchCv(token), {
    enabled: !!token
  });

export const useCreateCvMutation = () => {
  const { token } = useAccessToken();
  const queryClient = useQueryClient();

  return useMutation(
    [TALENT_CV_QUERY_KEY, 'create', token],
    (payload: CreateCvRequest) => cvApi.createCv(token, payload),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries([TALENT_CV_QUERY_KEY]);
      }
    }
  );
};

export const useUpdateCvMutation = () => {
  const { token } = useAccessToken();
  const queryClient = useQueryClient();

  return useMutation(
    [TALENT_CV_QUERY_KEY, 'update', token],
    (payload: CreateCvRequest) => cvApi.updateCv(token, payload),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries([TALENT_CV_QUERY_KEY]);
      }
    }
  );
};

export const useDeleteCvMutation = () => {
  const { token } = useAccessToken();
  const queryClient = useQueryClient();

  return useMutation(
    [TALENT_CV_QUERY_KEY, 'delete', token],
    () => cvApi.deleteCv(token),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries([TALENT_CV_QUERY_KEY]);
      }
    }
  );
};
